import React from 'react';
import styled from 'styled-components';

const FlagNew = ({ className }) => <Flag className={className}>novo</Flag>;

export default FlagNew;

const Flag = styled.span`
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;
  font-weight: 600;
  font-size: 11px;
  text-decoration: none;
  line-height: 1.25rem;
  padding: 0 6px;
  display: inline-block;
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  line-height: 20px;
`;
